
/**============================================================
*   [iOSBodyChange]
*   description : iOS vhズレ解消の処理を記述
============================================================*/
import viewportUnitsBuggyfill from 'viewport-units-buggyfill';

viewportUnitsBuggyfill.init();
window.addEventListener('resize', viewportUnitsBuggyfill.refresh, true);
